export const lightGrey = '#e4ecf2';
export const lightGrey2 = '#A9ABB4';
export const borderGrey = '#e9ecef';
export const primaryGrey = '#2B2D40';
export const secondaryGrey = '#757f98';
export const primaryOrange = '#ef4923';
export const primaryBlue = '#008fcc';
export const lightBlue = '#69a5ff54';
export const darkBlue = '#1D2E56';
export const darkBlue2 = '#1D2E56';
export const white = '#ffffff';
export const primaryRed = '#EA5757';
export const infoBackground = '#d5f0fa';
export const infoBlue = '#1c6c8b';
export const successGreen = '#0AAF42';
export const accentGreen = '#93D19F';
export const facebookBlue = '#4267B2';
export const twitterBlue = '#1DA1F2';
export const linkedInBlue = '#0E76A8';
export const yellow = '#E2AA48';
export const primaryGreen = '#328B4C';
export const lightPurple = '#6B74E4';
export const primaryPurple = '#560E59';
export const interviewBlue = '#0097B2';
